import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'https://prestijcrm.duckdns.org';
const KATEGORILER = ['daire', 'villa', 'mustakil', 'isyeri', 'dukkan', 'arsa', 'tarla','yazlik','fabrika'];
const TIPLER = ['satilik', 'kiralik'];
const DURUMLAR = ['aktif', 'pasif', 'satildi', 'kiralandi'];
const ODA = ['1+0','1+1','2+1','3+1','4+1','5+1','6+'];
const bos = { baslik:'', aciklama:'', tip:'satilik', kategori:'daire', fiyat:'', alan_m2:'', oda_sayisi:'', kat:'', kat_sayisi:'', esyali:'', sehir:'', ilce:'', mahalle:'', adres:'', durum:'aktif', mulk_sahibi:'', mulk_sahibi_tel:'', sozlesme_tarihi:'', tanitim_video_gonderim_tarihi:null };

export default function Listings() {
  const [ilanlar, setIlanlar] = useState([]);
  const [total, setTotal] = useState(0);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(bos);
  const [duzenleId, setDuzenleId] = useState(null);
  const [filters, setFilters] = useState({ search:'', tip:'', kategori:'', durum:'' });
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');
  const [fotograflar, setFotograflar] = useState([]);
  const [fotoYukleniyor, setFotoYukleniyor] = useState(false);
  const [disaridanMod, setDisaridanMod] = useState(false);
  const [surukleniyor, setSurukleniyor] = useState(false);
  const [videoYukleniyor, setVideoYukleniyor] = useState(false);
  const [eslesenMusteriler, setEslesenMusteriler] = useState([]);
  const [iceAktarMetin, setIceAktarMetin] = useState('');
  const [iceAktarYukleniyor, setIceAktarYukleniyor] = useState(false);
  const [iceAktarHata, setIceAktarHata] = useState('');
  const [ekFiltre, setEkFiltre] = useState('');
  const [esyaFiltre, setEsyaFiltre] = useState('');
  const [tanitimModal, setTanitimModal] = useState(null);
  const [videoDosya, setVideoDosya] = useState(null);
  const [videoHazirlaniyor, setVideoHazirlaniyor] = useState(false);
  const [adim1, setAdim1] = useState(false);
  const [siralama, setSiralama] = useState('fiyat_artan');
  const [mobil, setMobil] = useState(typeof window !== 'undefined' && window.innerWidth < 768);
  useEffect(() => { const h = () => setMobil(window.innerWidth < 768); window.addEventListener('resize', h); return () => window.removeEventListener('resize', h); }, []);
  const [eslModal, setEslModal] = useState(null);
  const [eslListe, setEslListe] = useState([]);
  const [eslYukleniyor, setEslYukleniyor] = useState(false);
  const token = localStorage.getItem('token');
  const headers = { Authorization: 'Bearer ' + token };

  const listele = async () => {
    setYukleniyor(true);
    try {
      const p = new URLSearchParams();
      if (filters.search) p.append('search', filters.search);
      if (filters.tip) p.append('tip', filters.tip);
      if (filters.kategori) p.append('kategori', filters.kategori);
      if (filters.durum) p.append('durum', filters.durum);
      p.append('kaynak', 'manuel');
      const res = await axios.get(API + '/api/ilanlar?' + p, { headers });
      setIlanlar(res.data.ilanlar); setTotal(res.data.total);
    } catch(e) { console.error(e); } finally { setYukleniyor(false); }
  };

  useEffect(() => { listele(); }, [filters]);

  useEffect(() => {
    if (duzenleId) {
      axios.get(API + '/api/ilanlar/' + duzenleId + '/fotograflar', { headers })
        .then(r => setFotograflar(r.data)).catch(() => {});
      axios.get(API + '/api/ilanlar/' + duzenleId + '/eslesen-musteriler', { headers })
        .then(r => setEslesenMusteriler(r.data.musteriler || [])).catch(() => {});
    } else { setFotograflar([]); setEslesenMusteriler([]); }
  }, [duzenleId]);

  const acModal = (ilan=null) => {
    setForm(ilan ? {...bos, ...ilan, sozlesme_tarihi: ilan.sozlesme_tarihi ? ilan.sozlesme_tarihi.split('T')[0] : ''} : bos);
    setDuzenleId(ilan ? ilan.id : null);
    setHata(''); setIceAktarMetin(''); setIceAktarHata(''); setDisaridanMod(false); setModal(true);
  };

  const metindenIceAktar = async () => {
    if (!iceAktarMetin.trim()) return;
    setIceAktarYukleniyor(true); setIceAktarHata('');
    try {
      const r = await axios.post(API + '/api/ilanlar/parse-metin', { metin: iceAktarMetin }, { headers });
      const { ilan_no, ...alanlar } = r.data;
      setHata('');
      setForm(p => ({ ...p, ...alanlar }));
      setDisaridanMod(true); // baska ilandan alinan bilgiler -> fotograflar da varsayilan olarak 'yayinlanmaz'
    } catch(e) { setIceAktarHata(e.response?.data?.error || 'Metin ayristirilamadi.'); }
    finally { setIceAktarYukleniyor(false); }
  };

  const kaydet = async () => {
    if (!form.baslik || !form.tip || !form.kategori) { setHata('Baslik, tip ve kategori zorunludur.'); return; }
    setKaydediliyor(true);
    try {
      const data = {...form, fiyat: form.fiyat||null, alan_m2: form.alan_m2||null, sozlesme_tarihi: form.sozlesme_tarihi||null};
      if (duzenleId) await axios.put(API + '/api/ilanlar/' + duzenleId, data, { headers });
      else { const r = await axios.post(API + '/api/ilanlar', data, { headers }); setDuzenleId(r.data.id); listele(); return; }
      setModal(false); listele();
    } catch(e) { setHata(e.response?.data?.error || 'Bir hata olustu.'); }
    finally { setKaydediliyor(false); }
  };

  const sil = async (id) => {
    if (!window.confirm('Bu ilani silmek istediginize emin misiniz?')) return;
    try { await axios.delete(API + '/api/ilanlar/' + id, { headers }); listele(); }
    catch(e) { alert('Silme hatasi'); }
  };

  const fotografYukle = async (files) => {
    if (!files||!files.length) return;
    if (!duzenleId) { alert('Fotograf eklemek icin once ilani Kaydedin.'); return; }
    const resimler = Array.from(files).filter(fil => fil.type && fil.type.startsWith('image/'));
    if (!resimler.length) { alert('Sadece resim dosyasi yuklenebilir.'); return; }
    setFotoYukleniyor(true);
    const fd = new FormData();
    fd.append('disaridan', disaridanMod ? '1' : '0');
    resimler.slice(0, 20).forEach((fil, n) => fd.append('fotograflar', fil, fil.name && fil.name !== 'image.png' ? fil.name : ('yapistirilan-' + Date.now() + '-' + n + '.' + ((fil.type.split('/')[1]||'png').replace('jpeg','jpg')))));
    try {
      await axios.post(API+'/api/ilanlar/'+duzenleId+'/fotograflar', fd, {headers:{Authorization:'Bearer '+token}});
      const r = await axios.get(API+'/api/ilanlar/'+duzenleId+'/fotograflar',{headers});
      setFotograflar(r.data);
    } catch(e){alert('Yukleme hatasi: '+(e.response?.data?.error||e.message));}
    finally{setFotoYukleniyor(false);}
  };

  const disaridanDegistir = async (foto) => {
    try {
      await axios.put(API+'/api/ilanlar/'+duzenleId+'/fotograflar/'+foto.id+'/disaridan', { disaridan: !foto.disaridan }, {headers});
      setFotograflar(prev => prev.map(fi => fi.id===foto.id ? {...fi, disaridan: !foto.disaridan} : fi));
    } catch(e) { alert('Hata'); }
  };

  // Ctrl+V ile panodaki resmi yukle (ilan penceresi acikken)
  useEffect(() => {
    if (!modal) return;
    const yapistir = (e) => {
      const items = Array.from((e.clipboardData && e.clipboardData.items) || []);
      const dosyalar = items.filter(it => it.kind === 'file' && it.type.startsWith('image/')).map(it => it.getAsFile()).filter(Boolean);
      if (!dosyalar.length) return; // resim yoksa normal yapistirma devam etsin
      e.preventDefault();
      fotografYukle(dosyalar);
    };
    window.addEventListener('paste', yapistir);
    return () => window.removeEventListener('paste', yapistir);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal, duzenleId, disaridanMod]);

  // Buton ile panodan resim okuma (Chrome: izin sorabilir -> "Izin ver")
  const panodanYapistir = async () => {
    if (!navigator.clipboard || !navigator.clipboard.read) { alert('Bu tarayici panodan okumayi desteklemiyor. Resmi kesikli kutuya tiklayip Ctrl+V ile yapistirin.'); return; }
    try {
      const ogeler = await navigator.clipboard.read();
      const dosyalar = [];
      for (const oge of ogeler) {
        const tip = oge.types.find(t => t.startsWith('image/'));
        if (tip) { const blob = await oge.getType(tip); dosyalar.push(new File([blob], 'yapistirilan-' + Date.now() + '-' + dosyalar.length + '.' + (tip.split('/')[1]||'png').replace('jpeg','jpg'), { type: tip })); }
      }
      if (!dosyalar.length) { alert('Panoda resim yok. Once Windows+Shift+S ile fotografin alintisini alin.'); return; }
      fotografYukle(dosyalar);
    } catch (e) { alert('Panoya erisilemedi: ' + (e.message || e) + '\nChrome izin sorduysa "Izin ver" deyin ve tekrar deneyin.'); }
  };

  const anaFotoSec = async (fotoId) => {
    try {
      await axios.put(API+'/api/ilanlar/'+duzenleId+'/fotograflar/'+fotoId+'/ana',{},{headers});
      const r = await axios.get(API+'/api/ilanlar/'+duzenleId+'/fotograflar',{headers});
      setFotograflar(r.data);
    } catch(e){alert('Hata');}
  };

  const fotografSilFunc = async (fotoId) => {
    if(!window.confirm('Fotografu silmek istiyor musunuz?')) return;
    try {
      await axios.delete(API+'/api/ilanlar/'+duzenleId+'/fotograflar/'+fotoId,{headers});
      setFotograflar(prev=>prev.filter(fi=>fi.id!==fotoId));
    } catch(e){alert('Silme hatasi');}
  };

  const videoYukle = async (file) => {
    if (!file || !duzenleId) return;
    setVideoYukleniyor(true);
    const fd = new FormData();
    fd.append('video', file);
    fd.append('ilanId', duzenleId);
    fd.append('title', form.baslik);
    fd.append('description', form.aciklama || '');
    try {
      const r = await axios.post(API+'/api/youtube/upload', fd, {headers:{Authorization:'Bearer '+token}});
      f('youtube_url', r.data.url);
      listele();
    } catch(e){ alert('Video yukleme hatasi: '+(e.response?.data?.error||e.message)); }
    finally { setVideoYukleniyor(false); }
  };

  const tanitimKalanGun = form.tanitim_video_gonderim_tarihi ? Math.max(0, 90 - Math.floor((Date.now()-new Date(form.tanitim_video_gonderim_tarihi).getTime())/86400000)) : 0;

  const tanitimVideoGonder = async () => {
    if (!duzenleId) return;
    if (!form.mulk_sahibi_tel) { alert('Bu ilan icin mulk sahibi telefonu girilmemis.'); return; }
    const num = waNumaraNormallestir(form.mulk_sahibi_tel);
    if (!num || num.length < 11) { alert('Gecerli bir mulk sahibi telefonu yok.'); return; }
    try {
      const r = await axios.post(API+'/api/ilanlar/'+duzenleId+'/tanitim-video-gonder', {}, {headers});
      f('tanitim_video_gonderim_tarihi', r.data.gonderim_tarihi);
      listele();
      tanitimAkisiAc(num, form.mulk_sahibi);
    } catch(e) { alert(e.response?.data?.error || 'Gonderim hatasi'); }
  };

  const waNumaraNormallestir = (raw) => {
    let d = String(raw||"").replace(/\D/g,"");
    if (!d) return "";
    if (d.startsWith("0")) d = "90"+d.slice(1);
    else if (!d.startsWith("90")) d = "90"+d;
    return d;
  };
  const musteriyeWhatsappGonder = (musteri) => {
    const num = waNumaraNormallestir(musteri.whatsapp_number || musteri.phone);
    if (!num || num.length < 11) { alert('Bu musterinin gecerli bir WhatsApp/telefon numarasi yok.'); return; }
    const satirlar = [
      `Merhaba ${musteri.name}, size uygun bir ilanimiz var:`,
      form.baslik,
      `${form.tip==='satilik'?'Satilik':'Kiralik'}${form.oda_sayisi?' | '+form.oda_sayisi:''}${form.fiyat?' | '+Number(form.fiyat).toLocaleString('tr-TR')+' TL':''}${(form.sehir||form.ilce)?' | '+[form.sehir,form.ilce].filter(Boolean).join('/'):''}`,
    ];
    const kendiFotolar = fotograflar.filter(fo=>!fo.disaridan);
    const anaFoto = kendiFotolar.find(fo=>fo.ana_fotograf) || kendiFotolar[0];
    if (anaFoto) satirlar.push(`Fotograf: https://prestijcrm.duckdns.org${anaFoto.dosya_yolu}`);
    if (form.youtube_url) satirlar.push(`Video: ${form.youtube_url}`);
    window.open(`https://wa.me/${num}?text=${encodeURIComponent(satirlar.join('\n'))}`, '_blank');
  };

  const TANITIM_URL = API + '/uploads/tanitim/prestij-tanitim.mp4';
  const dosyaPaylasilabilir = typeof navigator !== 'undefined' && !!navigator.canShare;
  const tanitimAkisiAc = async (num, ad) => {
    setAdim1(false); setTanitimModal({ num, ad: (ad || '').trim() });
    if (videoDosya || !dosyaPaylasilabilir) return;
    setVideoHazirlaniyor(true);
    try {
      const b = await (await fetch(TANITIM_URL)).blob();
      const file = new File([b], 'Prestij-Gayrimenkul-Tanitim.mp4', { type: 'video/mp4' });
      if (navigator.canShare({ files: [file] })) setVideoDosya(file);
    } catch (e) { console.error(e); }
    finally { setVideoHazirlaniyor(false); }
  };
  const tanitimSelam = (ad) => `Merhaba${ad ? ' ' + ad : ''}, ben Tolga Çetin – Prestij Gayrimenkul. İlanınızı gördük, gayrimenkulünüzü müşterilerimize tanıtmak isteriz. Kısa tanıtım videomuzu hemen ardından gönderiyorum.`;
  const sohbetiAc = () => { window.open(`https://wa.me/${tanitimModal.num}?text=${encodeURIComponent(tanitimSelam(tanitimModal.ad))}`, '_blank'); setAdim1(true); };
  const videoyuPaylas = async () => {
    try { await navigator.share({ files: [videoDosya], text: 'Prestij Gayrimenkul tanıtım videomuz' }); }
    catch (e) { if (e.name !== 'AbortError') alert('Paylaşım açılamadı: ' + e.message); }
  };
  const tanitimGunKaldi = (i) => i.tanitim_video_gonderim_tarihi ? Math.max(0, 90 - Math.floor((Date.now()-new Date(i.tanitim_video_gonderim_tarihi).getTime())/86400000)) : 0;
  const hizliTanitim = async (i) => {
    const num = waNumaraNormallestir(i.mulk_sahibi_tel);
    if (!num || num.length < 11) { alert('Bu ilanda mulk sahibi telefonu yok. Duzenle ile telefonu ekleyin.'); return; }
    try { await axios.post(API+'/api/ilanlar/'+i.id+'/tanitim-video-gonder', {}, {headers}); }
    catch(e) { alert(e.response?.data?.error || 'Gonderim hatasi'); return; }
    tanitimAkisiAc(num, i.mulk_sahibi);
    listele();
  };
  const eslesenleriAc = async (i) => {
    setEslModal(i); setEslListe([]); setEslYukleniyor(true);
    try { const r = await axios.get(API+'/api/ilanlar/'+i.id+'/eslesen-musteriler', {headers}); setEslListe(r.data.musteriler||[]); }
    catch(e) { setEslListe([]); } finally { setEslYukleniyor(false); }
  };
  const ilaniMusteriyeGonder = (i, m) => {
    const num = waNumaraNormallestir(m.whatsapp_number || m.phone);
    if (!num || num.length < 11) { alert('Bu musterinin gecerli bir WhatsApp/telefon numarasi yok.'); return; }
    const satirlar = [
      `Merhaba ${m.name}, aradiginiz kriterlere uygun bir gayrimenkul var:`,
      i.baslik,
      `${i.tip==='satilik'?'Satilik':'Kiralik'}${i.oda_sayisi?' | '+i.oda_sayisi:''}${i.fiyat?' | '+Number(i.fiyat).toLocaleString('tr-TR')+' TL':''}${(i.ilce||i.mahalle)?' | '+[i.ilce,i.mahalle].filter(Boolean).join(' / '):''}`,
    ];
    if (i.youtube_url) satirlar.push(`Video: ${i.youtube_url}`);
    satirlar.push('', 'Prestij Gayrimenkul - 0532 130 62 72');
    window.open(`https://wa.me/${num}?text=${encodeURIComponent(satirlar.join('\n'))}`, '_blank');
  };
  const gosterilen = ilanlar.filter(i => {
    if (esyaFiltre === 'bilinmiyor' ? !!i.esyali : (esyaFiltre && i.esyali !== esyaFiltre)) return false;
    if (ekFiltre === 'eslesen') return i.eslesen_sayisi > 0;
    if (ekFiltre === 'tanitim') return !i.tanitim_video_gonderim_tarihi || tanitimGunKaldi(i) === 0;
    if (ekFiltre === 'telefonsuz') return !i.mulk_sahibi_tel;
    return true;
  }).sort((a, b) => {
    if (siralama === 'yeni') return new Date(b.created_at) - new Date(a.created_at);
    const fa = Number(a.fiyat) || null, fb = Number(b.fiyat) || null;
    if (fa === null && fb === null) return 0;
    if (fa === null) return 1;
    if (fb === null) return -1;
    return siralama === 'fiyat_azalan' ? fb - fa : fa - fb;
  });
  const esyaEtiket = (e) => e === 'esyali' ? 'Eşyalı' : e === 'esyasiz' ? 'Eşyasız' : null;
  const katYazi = (i) => i.kat ? (i.kat_sayisi ? `${i.kat}. kat / ${i.kat_sayisi} katlı` : (/^\d+$/.test(String(i.kat)) ? `${i.kat}. kat` : i.kat)) : (i.kat_sayisi ? `${i.kat_sayisi} katlı bina` : null);
  const ozet = {
    eslesen: ilanlar.filter(i => i.eslesen_sayisi > 0).length,
    tanitimBekleyen: ilanlar.filter(i => i.mulk_sahibi_tel && (!i.tanitim_video_gonderim_tarihi || tanitimGunKaldi(i) === 0)).length,
    telefonsuz: ilanlar.filter(i => !i.mulk_sahibi_tel).length,
  };

  const durumRenk = (d) => ({ aktif:'#22c55e', pasif:'#94a3b8', satildi:'#f59e0b', kiralandi:'#3b82f6' }[d] || '#94a3b8');
  const formatFiyat = (f) => f ? Number(f).toLocaleString('tr-TR') + ' TL' : '-';
  const f = (k,v) => { setHata(''); setForm(p => ({...p, [k]:v})); };
  const inp = (extra={}) => ({width:'100%', padding:'10px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:14, boxSizing:'border-box', ...extra});
  const lbl = {display:'block', fontSize:13, fontWeight:600, color:'#374151', marginBottom:6};

  return (
    <div style={{padding:'24px', fontFamily:'Inter,sans-serif'}}>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24}}>
        <div>
          <h1 style={{margin:0, fontSize:24, fontWeight:700, color:'#1e293b'}}>Ilanlar</h1>
          <p style={{margin:'4px 0 0', color:'#64748b', fontSize:14}}>{total} ilan · Bu ilanlar iki is icin kullanilir: <b>1)</b> ilan sahiplerine tanitim videomuzu gondermek, <b>2)</b> musterilerimizin aradigi kriterlere uyan gayrimenkulleri bulmak.</p>
        </div>
        <button onClick={() => acModal()} style={{background:'#2563eb', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', cursor:'pointer', fontSize:14, fontWeight:600}}>+ Yeni Ilan</button>
      </div>

      <div style={{display:'flex', gap:12, marginBottom:20, flexWrap:'wrap'}}>
        <input placeholder="Ara..." value={filters.search} onChange={e => setFilters(p=>({...p,search:e.target.value}))} style={{padding:'9px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:14, minWidth:180}} />
        <select value={filters.tip} onChange={e => setFilters(p=>({...p,tip:e.target.value}))} style={{padding:'9px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:14}}>
          <option value="">Tum Tipler</option>
          {TIPLER.map(t => <option key={t} value={t}>{t === 'satilik' ? 'Satilik' : 'Kiralik'}</option>)}
        </select>
        <select value={filters.kategori} onChange={e => setFilters(p=>({...p,kategori:e.target.value}))} style={{padding:'9px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:14}}>
          <option value="">Tum Kategoriler</option>
          {KATEGORILER.map(k => <option key={k} value={k}>{k.charAt(0).toUpperCase()+k.slice(1)}</option>)}
        </select>
        <select value={filters.durum} onChange={e => setFilters(p=>({...p,durum:e.target.value}))} style={{padding:'9px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:14}}>
          <option value="">Tum Durumlar</option>
          {DURUMLAR.map(d => <option key={d} value={d}>{d.charAt(0).toUpperCase()+d.slice(1)}</option>)}
        </select>
        <select value={esyaFiltre} onChange={e => setEsyaFiltre(e.target.value)} style={{padding:'9px 14px', border:'1px solid '+(esyaFiltre?'#2563eb':'#e2e8f0'), borderRadius:8, fontSize:14}}>
          <option value="">Eşyalı + Eşyasız</option>
          <option value="esyali">Sadece Eşyalı</option>
          <option value="esyasiz">Sadece Eşyasız</option>
          <option value="bilinmiyor">Eşya durumu girilmemiş</option>
        </select>
        <select value={siralama} onChange={e => setSiralama(e.target.value)} style={{padding:'9px 14px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:14}}>
          <option value="fiyat_artan">Fiyat: düşükten yükseğe</option>
          <option value="fiyat_azalan">Fiyat: yüksekten düşüğe</option>
          <option value="yeni">En yeni eklenen</option>
        </select>
      </div>

      <div style={{display:'flex', gap:12, marginBottom:16, flexWrap:'wrap'}}>
        {[
          ['', 'Tum ilanlar', ilanlar.length, '#2563eb'],
          ['eslesen', 'Musterisi olan ilanlar', ozet.eslesen, '#16a34a'],
          ['tanitim', 'Tanitim videosu bekleyen', ozet.tanitimBekleyen, '#25a244'],
          ['telefonsuz', 'Mulk sahibi telefonu eksik', ozet.telefonsuz, '#ea580c'],
        ].map(([k, ad, n, renk]) => (
          <button key={k} onClick={() => setEkFiltre(k)} style={{flex:1, minWidth:150, textAlign:'left', background: ekFiltre===k ? renk+'18' : '#fff', border: '2px solid '+(ekFiltre===k ? renk : '#e2e8f0'), borderRadius:12, padding:'12px 16px', cursor:'pointer'}}>
            <div style={{fontSize:12, color:'#64748b', fontWeight:600}}>{ad}</div>
            <div style={{fontSize:24, fontWeight:700, color:renk}}>{n}</div>
          </button>
        ))}
      </div>

      <div style={{background:'#fff', borderRadius:12, boxShadow:'0 1px 3px rgba(0,0,0,0.1)', overflow:'auto'}}>
        {yukleniyor ? <div style={{padding:40, textAlign:'center', color:'#64748b'}}>Yukleniyor...</div>
        : gosterilen.length === 0 ? <div style={{padding:40, textAlign:'center', color:'#64748b'}}>{ilanlar.length ? 'Bu filtreye uyan ilan yok.' : 'Henuz ilan eklenmemis.'}</div>
        : mobil ? <div>
            {gosterilen.map(i => (
              <div key={i.id} style={{padding:'14px 16px', borderBottom:'1px solid #f1f5f9'}}>
                <div style={{fontWeight:700, color:'#1e293b', fontSize:15, lineHeight:1.3}}>{i.baslik}</div>
                <div style={{display:'flex', alignItems:'baseline', justifyContent:'space-between', gap:8, marginTop:6}}>
                  <span style={{fontSize:20, fontWeight:800, color:'#0f172a'}}>{formatFiyat(i.fiyat)}</span>
                  <span style={{padding:'2px 10px', borderRadius:20, fontSize:12, fontWeight:600, background: i.tip==='satilik'?'#dbeafe':'#dcfce7', color: i.tip==='satilik'?'#1d4ed8':'#16a34a'}}>{i.tip === 'satilik' ? 'Satılık' : 'Kiralık'}</span>
                </div>
                <div style={{display:'flex', flexWrap:'wrap', gap:6, marginTop:8}}>
                  <span style={{background:'#f1f5f9', borderRadius:6, padding:'3px 8px', fontSize:13, fontWeight:600}}>🛏 {i.oda_sayisi || 'Oda ?'}</span>
                  <span style={{background:'#f1f5f9', borderRadius:6, padding:'3px 8px', fontSize:13, fontWeight:600}}>🏢 {katYazi(i) || 'Kat ?'}</span>
                  {esyaEtiket(i.esyali) && <span style={{background: i.esyali==='esyali'?'#fef3c7':'#e0e7ff', color: i.esyali==='esyali'?'#92400e':'#3730a3', borderRadius:6, padding:'3px 8px', fontSize:13, fontWeight:600}}>{esyaEtiket(i.esyali)}</span>}
                  {i.alan_m2 && <span style={{background:'#f1f5f9', borderRadius:6, padding:'3px 8px', fontSize:13}}>{i.alan_m2} m²</span>}
                </div>
                <div style={{fontSize:12, color:'#64748b', marginTop:6}}>{[i.kategori, i.ilce, i.mahalle].filter(Boolean).join(' · ')}{i.mulk_sahibi_tel ? ' · ' + i.mulk_sahibi_tel : ''}</div>
                <div style={{display:'flex', gap:6, marginTop:8, flexWrap:'wrap'}}>
                  <button onClick={() => acModal(i)} style={{background:'#dbeafe', color:'#1d4ed8', border:'none', borderRadius:6, padding:'6px 12px', fontSize:13, fontWeight:600}}>Düzenle</button>
                  {i.eslesen_sayisi > 0 && <button onClick={() => eslesenleriAc(i)} style={{background:'#dcfce7', color:'#15803d', border:'none', borderRadius:6, padding:'6px 12px', fontSize:13, fontWeight:700}}>👥 {i.eslesen_sayisi} müşteri</button>}
                  {i.mulk_sahibi_tel && <a href={'tel:' + i.mulk_sahibi_tel} style={{background:'#f1f5f9', color:'#334155', borderRadius:6, padding:'6px 12px', fontSize:13, fontWeight:600, textDecoration:'none'}}>📞 Ara</a>}
                </div>
              </div>
            ))}
          </div>
        : <table style={{width:'100%', borderCollapse:'collapse', minWidth:900}}>
            <thead>
              <tr style={{background:'#f8fafc', borderBottom:'1px solid #e2e8f0'}}>
                {['Baslik','Fiyat','Oda','Kat','Tip','Kategori','Alan','Sehir/Ilce','Mulk Sahibi','Eslesen Musteri','Tanitim Videosu','Durum','Islem'].map(h =>
                  <th key={h} style={{padding:'12px 16px', textAlign:'left', fontSize:13, fontWeight:600, color:'#64748b', whiteSpace:'nowrap'}}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {gosterilen.map((i, idx) => (
                <tr key={i.id} style={{borderBottom:'1px solid #f1f5f9', background: idx%2===0 ? '#fff' : '#fafafa'}}>
                  <td style={{padding:'12px 16px', fontSize:14}}>
                    <div style={{fontWeight:600, color:'#1e293b'}}>{i.baslik}</div>
                    {i.mahalle && <div style={{fontSize:12, color:'#64748b'}}>{i.mahalle}</div>}
                  </td>
                  <td style={{padding:'12px 16px', fontSize:14, fontWeight:600}}>{formatFiyat(i.fiyat)}</td>
                  <td style={{padding:'12px 16px', fontSize:14}}>{i.oda_sayisi || '-'}{esyaEtiket(i.esyali) && <div style={{fontSize:11, fontWeight:700, color: i.esyali==='esyali'?'#92400e':'#3730a3'}}>{esyaEtiket(i.esyali)}</div>}</td>
                  <td style={{padding:'12px 16px', fontSize:14}}>{i.kat ? (i.kat_sayisi ? `${i.kat}. kat / ${i.kat_sayisi} katlı` : i.kat) : (i.kat_sayisi ? `${i.kat_sayisi} katlı bina` : '-')}</td>
                  <td style={{padding:'12px 16px', fontSize:14}}>
                    <span style={{display:'inline-block', padding:'3px 10px', borderRadius:20, fontSize:12, fontWeight:600, background: i.tip==='satilik'?'#dbeafe':'#dcfce7', color: i.tip==='satilik'?'#1d4ed8':'#16a34a'}}>
                      {i.tip === 'satilik' ? 'Satilik' : 'Kiralik'}
                    </span>
                  </td>
                  <td style={{padding:'12px 16px', fontSize:14}}>{i.kategori}</td>
                  <td style={{padding:'12px 16px', fontSize:14}}>{i.alan_m2 ? i.alan_m2 + ' m2' : '-'}</td>
                  <td style={{padding:'12px 16px', fontSize:14}}>
                    <div>{i.sehir || '-'}</div>
                    {i.ilce && <div style={{fontSize:12, color:'#64748b'}}>{i.ilce}</div>}
                  </td>
                  <td style={{padding:'12px 16px', fontSize:14}}>
                    <div>{i.mulk_sahibi || '-'}</div>
                    {i.mulk_sahibi_tel && <div style={{fontSize:12, color:'#64748b'}}>{i.mulk_sahibi_tel}</div>}
                  </td>
                  <td style={{padding:'12px 16px', fontSize:14}}>
                    {i.eslesen_sayisi > 0 ? (
                      <button onClick={() => eslesenleriAc(i)} style={{background:'#dcfce7', color:'#15803d', border:'1px solid #86efac', borderRadius:20, padding:'4px 12px', cursor:'pointer', fontSize:12, fontWeight:700, whiteSpace:'nowrap'}}>
                        👥 {i.eslesen_sayisi} musteri{i.eslesen_bolgede > 0 ? ` (${i.eslesen_bolgede} bolgede)` : ''}
                      </button>
                    ) : <span style={{color:'#94a3b8', fontSize:12}}>Yok</span>}
                  </td>
                  <td style={{padding:'12px 16px', fontSize:14, whiteSpace:'nowrap'}}>
                    {i.tanitim_video_gonderim_tarihi ? (
                      <div style={{color:'#16a34a', fontSize:12, fontWeight:600}}>✓ {new Date(i.tanitim_video_gonderim_tarihi).toLocaleDateString('tr-TR')}</div>
                    ) : (
                      <div style={{color:'#94a3b8', fontSize:12}}>Gonderilmedi</div>
                    )}
                    {tanitimGunKaldi(i) > 0 ? (
                      <div style={{color:'#94a3b8', fontSize:11}}>{tanitimGunKaldi(i)} gun sonra tekrar</div>
                    ) : i.mulk_sahibi_tel ? (
                      <button onClick={() => hizliTanitim(i)} style={{marginTop:4, background:'#25D366', color:'#052e16', border:'none', borderRadius:6, padding:'4px 10px', cursor:'pointer', fontSize:12, fontWeight:700}}>🎬 Gonder</button>
                    ) : (
                      <div style={{color:'#ea580c', fontSize:11}}>Telefon yok</div>
                    )}
                  </td>
                  <td style={{padding:'12px 16px', fontSize:14}}>
                    <span style={{display:'inline-block', padding:'3px 10px', borderRadius:20, fontSize:12, fontWeight:600, background: durumRenk(i.durum)+'22', color: durumRenk(i.durum)}}>
                      {i.durum}
                    </span>
                  </td>
                  <td style={{padding:'12px 16px', fontSize:14, whiteSpace:'nowrap'}}>
                    <button onClick={() => acModal(i)} style={{background:'#dbeafe', color:'#1d4ed8', border:'none', borderRadius:6, padding:'5px 10px', cursor:'pointer', fontSize:12, fontWeight:600, marginRight:6}}>Duzenle</button>
                    <button onClick={() => sil(i.id)} style={{background:'#fee2e2', color:'#ef4444', border:'none', borderRadius:6, padding:'5px 10px', cursor:'pointer', fontSize:12, fontWeight:600}}>Sil</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>}
      </div>

      {tanitimModal && (
        <div onClick={() => setTanitimModal(null)} style={{position:'fixed', inset:0, background:'rgba(15,23,42,0.55)', zIndex:1100, display:'flex', alignItems:'center', justifyContent:'center', padding:16}}>
          <div onClick={e => e.stopPropagation()} style={{background:'#fff', borderRadius:14, padding:20, width:'100%', maxWidth:440, boxShadow:'0 20px 50px rgba(0,0,0,0.3)'}}>
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:4}}>
              <h3 style={{margin:0, fontSize:18, color:'#0f172a'}}>🎬 Tanıtım videosu gönder</h3>
              <button onClick={() => setTanitimModal(null)} style={{background:'none', border:'none', fontSize:22, cursor:'pointer', color:'#64748b'}}>×</button>
            </div>
            <div style={{fontSize:13, color:'#64748b', marginBottom:14}}>{tanitimModal.ad || 'Mülk sahibi'} · +{tanitimModal.num}</div>
            <div style={{border:'1px solid #e2e8f0', borderRadius:10, padding:12, marginBottom:10, background: adim1 ? '#f0fdf4' : '#fff'}}>
              <b style={{fontSize:14}}>1. Sohbeti açın ve selam mesajını gönderin</b>
              <div style={{fontSize:12, color:'#64748b', margin:'4px 0 8px'}}>Link içermez, sadece kısa bir tanıtım cümlesi. Böylece kişi sohbet listenizin en üstüne gelir.</div>
              <button onClick={sohbetiAc} style={{width:'100%', background:'#25D366', color:'#052e16', border:'none', borderRadius:8, padding:'10px', fontWeight:700, fontSize:14, cursor:'pointer'}}>{adim1 ? '✓ Sohbet açıldı (tekrar aç)' : 'WhatsApp sohbetini aç'}</button>
            </div>
            <div style={{border:'1px solid #e2e8f0', borderRadius:10, padding:12}}>
              <b style={{fontSize:14}}>2. Videoyu dosya olarak gönderin</b>
              {dosyaPaylasilabilir ? (
                <>
                  <div style={{fontSize:12, color:'#64748b', margin:'4px 0 8px'}}>Açılan pencerede <b>WhatsApp</b>'ı, sonra listenin en üstündeki <b>{tanitimModal.ad || 'kişiyi'}</b> seçip gönderin. Video, link değil doğrudan oynatılabilir dosya olarak gider.</div>
                  <button onClick={videoyuPaylas} disabled={!videoDosya} style={{width:'100%', background: videoDosya ? '#2563eb' : '#94a3b8', color:'#fff', border:'none', borderRadius:8, padding:'10px', fontWeight:700, fontSize:14, cursor: videoDosya ? 'pointer' : 'wait'}}>
                    {videoDosya ? '📤 Videoyu paylaş' : videoHazirlaniyor ? 'Video hazırlanıyor…' : 'Bu tarayıcı dosya paylaşımını desteklemiyor'}
                  </button>
                </>
              ) : (
                <>
                  <div style={{fontSize:12, color:'#64748b', margin:'4px 0 8px'}}>Bilgisayarda: videoyu indirin, WhatsApp'ta açılan sohbette <b>ataç (📎) → Fotoğraf ve video</b> ile indirilen dosyayı seçip gönderin. Telefondan CRM'i açarsanız bu adım tek dokunuşla yapılır.</div>
                  <a href={TANITIM_URL} download="Prestij-Gayrimenkul-Tanitim.mp4" style={{display:'block', textAlign:'center', background:'#2563eb', color:'#fff', borderRadius:8, padding:'10px', fontWeight:700, fontSize:14, textDecoration:'none'}}>⬇️ Videoyu indir</a>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {eslModal && (
        <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1100}} onClick={() => setEslModal(null)}>
          <div onClick={e => e.stopPropagation()} style={{background:'#fff', borderRadius:12, padding:24, width:'94%', maxWidth:640, maxHeight:'85vh', overflowY:'auto'}}>
            <h3 style={{margin:'0 0 4px', color:'#1e293b'}}>Bu ilani arayan musteriler</h3>
            <div style={{color:'#64748b', fontSize:13, marginBottom:14}}>{eslModal.baslik} · {eslModal.oda_sayisi || '-'} · {formatFiyat(eslModal.fiyat)} · {[eslModal.ilce, eslModal.mahalle].filter(Boolean).join(' / ')}</div>
            {eslYukleniyor ? <div style={{color:'#64748b'}}>Yukleniyor...</div>
            : eslListe.length === 0 ? <div style={{color:'#64748b'}}>Uygun musteri yok.</div>
            : eslListe.map(m => (
              <div key={m.id} style={{display:'flex', justifyContent:'space-between', alignItems:'center', gap:12, background:'#f8fafc', borderRadius:8, padding:'10px 12px', marginBottom:8, borderLeft:'4px solid '+({1:'#16a34a',2:'#2563eb',3:'#f59e0b',4:'#94a3b8'}[m.grup])}}>
                <div>
                  <div style={{fontWeight:700, fontSize:14, color:'#1e293b'}}>{m.name} <span style={{fontWeight:400, fontSize:12, color:'#64748b'}}>{m.whatsapp_number || m.phone || ''}</span></div>
                  <div style={{fontSize:12, color:'#64748b'}}>
                    {m.rooms ? m.rooms + ' · ' : ''}{m.budget_min || m.budget_max ? `${m.budget_min ? Number(m.budget_min).toLocaleString('tr-TR') : '-'} - ${m.budget_max ? Number(m.budget_max).toLocaleString('tr-TR') : '-'} TL` : 'butce yok'}
                    {(m.bolgeler && m.bolgeler.length) ? ' · ' + m.bolgeler.join(', ') : (m.district ? ' · ' + m.district : '')}
                  </div>
                  <div style={{fontSize:11, marginTop:2, display:'flex', gap:8, flexWrap:'wrap'}}>
                    {m.bolge_eslesti && <span style={{color:'#0f766e'}}>📍 Aradigi bolgede</span>}
                    {m.fiyat_durum === 'uygun' && m.butce_var && <span style={{color:'#15803d'}}>✓ Butcesinde</span>}
                    {m.fiyat_durum === 'yakin' && <span style={{color:'#b45309'}}>≈ Butceye yakin</span>}
                    {m.oda_uyar && <span style={{color:'#4338ca'}}>🛏 Oda uyuyor</span>}
                    {m.oda_bilinmiyor && <span style={{color:'#b45309'}}>🛏 Ilanda oda yok</span>}
                  </div>
                </div>
                <button onClick={() => ilaniMusteriyeGonder(eslModal, m)} style={{background:'#25D366', border:'none', borderRadius:6, padding:'7px 12px', color:'#052e16', cursor:'pointer', fontWeight:700, fontSize:12, whiteSpace:'nowrap'}}>WhatsApp'la Gonder</button>
              </div>
            ))}
            <button onClick={() => setEslModal(null)} style={{marginTop:10, background:'#f1f5f9', border:'none', borderRadius:8, padding:'8px 18px', cursor:'pointer', fontWeight:600}}>Kapat</button>
          </div>
        </div>
      )}

      {modal && (
        <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:20}}>
          <div style={{background:'#fff', borderRadius:16, padding:32, width:'100%', maxWidth:640, maxHeight:'90vh', overflowY:'auto', boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>
            <h2 style={{margin:'0 0 24px', fontSize:20, fontWeight:700}}>{duzenleId ? 'Ilan Duzenle' : 'Yeni Ilan Ekle'}</h2>
            {hata && <div style={{background:'#fef2f2', border:'1px solid #fecaca', color:'#dc2626', padding:'10px 14px', borderRadius:8, marginBottom:16, fontSize:14}}>{hata}</div>}

            {!duzenleId && (
              <div style={{background:'#f0f9ff', border:'1px solid #bae6fd', borderRadius:10, padding:16, marginBottom:20}}>
                <label style={{...lbl, color:'#0369a1'}}>Ilan Metninden Ice Aktar (sahibinden.com sayfasini kopyala-yapistir)</label>
                <textarea value={iceAktarMetin} onChange={e=>setIceAktarMetin(e.target.value)} style={inp({height:70, resize:'vertical', fontFamily:'inherit'})} placeholder="Ilan sayfasinin tamamini (Ctrl+A, Ctrl+C) buraya yapistir..." />
                {iceAktarHata && <div style={{color:'#dc2626', fontSize:13, marginTop:6}}>{iceAktarHata}</div>}
                <button onClick={metindenIceAktar} disabled={iceAktarYukleniyor || !iceAktarMetin.trim()} style={{marginTop:10, background:'#0284c7', color:'#fff', border:'none', borderRadius:8, padding:'8px 18px', cursor:'pointer', fontSize:13, fontWeight:600}}>
                  {iceAktarYukleniyor ? 'Ayristiriliyor...' : 'Formu Doldur'}
                </button>
              </div>
            )}

            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:16}}>
              <div style={{gridColumn:'1/-1'}}>
                <label style={lbl}>Baslik *</label>
                <input value={form.baslik} onChange={e => f('baslik',e.target.value)} style={inp()} placeholder="Ilan basligi" />
              </div>
              <div>
                <label style={lbl}>Tip *</label>
                <select value={form.tip} onChange={e => f('tip',e.target.value)} style={inp()}>
                  <option value="satilik">Satilik</option>
                  <option value="kiralik">Kiralik</option>
                </select>
              </div>
              <div>
                <label style={lbl}>Kategori *</label>
                <select value={form.kategori} onChange={e => f('kategori',e.target.value)} style={inp()}>
                  {KATEGORILER.map(k => <option key={k} value={k}>{k.charAt(0).toUpperCase()+k.slice(1)}</option>)}
                </select>
              </div>
              <div>
                <label style={lbl}>Fiyat (TL)</label>
                <input type="number" value={form.fiyat} onChange={e => f('fiyat',e.target.value)} style={inp()} placeholder="0" />
              </div>
              <div>
                <label style={lbl}>Alan (m2)</label>
                <input type="number" value={form.alan_m2} onChange={e => f('alan_m2',e.target.value)} style={inp()} placeholder="0" />
              </div>
              <div>
                <label style={lbl}>Oda Sayisi</label>
                <select value={form.oda_sayisi} onChange={e => f('oda_sayisi',e.target.value)} style={inp()}>
                  <option value="">Seciniz</option>
                  {ODA.map(o => <option key={o} value={o}>{o}</option>)}
                </select>
              </div>
              {['daire','villa','mustakil','yazlik'].includes(form.kategori) && <div>
                <label style={lbl}>Eşya Durumu</label>
                <select value={form.esyali || ''} onChange={e => f('esyali', e.target.value)} style={inp()}>
                  <option value="">Belirtilmemiş</option>
                  <option value="esyali">Eşyalı</option>
                  <option value="esyasiz">Eşyasız</option>
                </select>
              </div>}
              <div>
                <label style={lbl}>Kat</label>
                <input value={form.kat} onChange={e => f('kat',e.target.value)} style={inp()} placeholder="Ornek: 3, Zemin, Bahce Kat" />
              </div>
              <div>
                <label style={lbl}>Bina Kat Sayisi</label>
                <input value={form.kat_sayisi} onChange={e => f('kat_sayisi',e.target.value)} style={inp()} placeholder="Binanin toplam kat sayisi, orn: 5" />
              </div>
              <div>
                <label style={lbl}>Durum</label>
                <select value={form.durum} onChange={e => f('durum',e.target.value)} style={inp()}>
                  {DURUMLAR.map(d => <option key={d} value={d}>{d.charAt(0).toUpperCase()+d.slice(1)}</option>)}
                </select>
              </div>
              <div>
                <label style={lbl}>Sehir</label>
                <input value={form.sehir} onChange={e => f('sehir',e.target.value)} style={inp()} placeholder="Balikesir" />
              </div>
              <div>
                <label style={lbl}>Ilce</label>
                <input value={form.ilce} onChange={e => f('ilce',e.target.value)} style={inp()} placeholder="Karesi" />
              </div>
              <div style={{gridColumn:'1/-1'}}>
                <label style={lbl}>Mahalle</label>
                <input value={form.mahalle} onChange={e => f('mahalle',e.target.value)} style={inp()} placeholder="Bahcelievler Mah." />
              </div>
              <div style={{gridColumn:'1/-1'}}>
                <label style={lbl}>Adres</label>
                <input value={form.adres} onChange={e => f('adres',e.target.value)} style={inp()} placeholder="Tam adres" />
              </div>
              <div>
                <label style={lbl}>Mulk Sahibi</label>
                <input value={form.mulk_sahibi} onChange={e => f('mulk_sahibi',e.target.value)} style={inp()} placeholder="Ad Soyad" />
              </div>
              <div>
                <label style={lbl}>Mulk Sahibi Telefon</label>
                <input value={form.mulk_sahibi_tel} onChange={e => f('mulk_sahibi_tel',e.target.value)} style={inp()} placeholder="05xx xxx xx xx" />
              </div>
              <div>
                <label style={lbl}>Sozlesme Tarihi</label>
                <input type="date" value={form.sozlesme_tarihi} onChange={e => f('sozlesme_tarihi',e.target.value)} style={inp()} />
              </div>
              <div style={{gridColumn:'1/-1'}}>
                <label style={lbl}>Aciklama</label>
                <textarea value={form.aciklama} onChange={e => f('aciklama',e.target.value)} style={inp({height:80, resize:'vertical'})} placeholder="Ilan detaylari..." />
              </div>
            </div>

            <div style={{display:'flex', gap:12, marginTop:24, justifyContent:'flex-end'}}>
              <button onClick={() => setModal(false)} style={{background:'#f1f5f9', color:'#374151', border:'none', borderRadius:8, padding:'10px 20px', cursor:'pointer', fontSize:14, fontWeight:600}}>Iptal</button>
              <button onClick={kaydet} disabled={kaydediliyor} style={{background:'#2563eb', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', cursor:'pointer', fontSize:14, fontWeight:600}}>
                {kaydediliyor ? 'Kaydediliyor...' : duzenleId ? 'Guncelle' : 'Kaydet'}
              </button>
            </div>
        {duzenleId && (
          <div style={{marginTop:24,borderTop:'1px solid #e2e8f0',paddingTop:20}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
              <span style={{color:'#374151',fontSize:14,fontWeight:600}}>YouTube Video</span>
              <label style={{background:videoYukleniyor?'#7f1d1d':'#dc2626',color:'#fff',border:'none',borderRadius:8,padding:'8px 16px',cursor:'pointer',fontSize:13,fontWeight:600}}>
                {videoYukleniyor?'Yukleniyor...':(form.youtube_url?'Videoyu Degistir':'+ Video Ekle')}
                <input type="file" accept="video/*" style={{display:'none'}} onChange={e=>videoYukle(e.target.files[0])} disabled={videoYukleniyor}/>
              </label>
            </div>
            {videoYukleniyor && <p style={{color:'#64748b',fontSize:12,marginTop:-6}}>Buyuk videolar birkac dakika surebilir, pencereyi kapatmayin.</p>}
            {form.youtube_url ? (
              <a href={form.youtube_url} target="_blank" rel="noreferrer" style={{display:'inline-block',fontSize:13,color:'#dc2626',fontWeight:600,marginBottom:4}}>{form.youtube_url}</a>
            ) : (
              <p style={{color:'#64748b',fontSize:13,padding:'4px 0'}}>Henuz video eklenmedi</p>
            )}
          </div>
        )}

        {duzenleId && (
          <div style={{marginTop:24,borderTop:'1px solid #e2e8f0',paddingTop:20}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
              <span style={{color:'#374151',fontSize:14,fontWeight:600}}>Prestij Tanitim Videosu</span>
              <button onClick={tanitimVideoGonder} disabled={tanitimKalanGun>0} style={{background:'#25D366',color:'#052e16',border:'none',borderRadius:8,padding:'8px 16px',cursor:tanitimKalanGun>0?'not-allowed':'pointer',fontSize:13,fontWeight:700,opacity:tanitimKalanGun>0?0.5:1}}>
                WhatsApp'tan Gonder
              </button>
            </div>
            {form.tanitim_video_gonderim_tarihi ? (
              <p style={{color:'#64748b',fontSize:13}}>
                Son gonderim: {new Date(form.tanitim_video_gonderim_tarihi).toLocaleDateString('tr-TR')}
                {tanitimKalanGun>0 && ` — tekrar gonderim icin ${tanitimKalanGun} gun bekleyin (3 ay kurali)`}
              </p>
            ) : (
              <p style={{color:'#64748b',fontSize:13}}>Henuz gonderilmedi</p>
            )}
          </div>
        )}

        {duzenleId && (
          <div style={{marginTop:24,borderTop:'1px solid #e2e8f0',paddingTop:20}}>
            <span style={{color:'#374151',fontSize:14,fontWeight:600}}>Eslesen Musteriler ({eslesenMusteriler.length})</span>
            {eslesenMusteriler.length===0 ? (
              <p style={{color:'#64748b',fontSize:13,padding:'8px 0'}}>Bu ilana uygun musteri bulunamadi.</p>
            ) : (
              <div style={{marginTop:10,display:'flex',flexDirection:'column',gap:8}}>
                {eslesenMusteriler.map(m=>(
                  <div key={m.id} style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:12,background:'#f8fafc',borderRadius:8,padding:'8px 12px'}}>
                    <div>
                      <div style={{fontWeight:600,fontSize:13,color:'#1e293b'}}>{m.name}</div>
                      <div style={{fontSize:12,color:'#64748b'}}>{m.budget_min?Number(m.budget_min).toLocaleString('tr-TR'):'-'} - {m.budget_max?Number(m.budget_max).toLocaleString('tr-TR'):'-'} TL{m.district?' | '+m.district:''}</div>
                    </div>
                    <button onClick={()=>musteriyeWhatsappGonder(m)} style={{background:'#25D366',border:'none',borderRadius:6,padding:'6px 12px',color:'#052e16',cursor:'pointer',fontWeight:700,fontSize:12,whiteSpace:'nowrap'}}>WhatsApp</button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {duzenleId && (
          <div style={{marginTop:24,borderTop:'1px solid #334155',paddingTop:20,borderRadius:8,outline:surukleniyor?'3px dashed #2563eb':'none',background:surukleniyor?'#2563eb11':'transparent'}}
            onDragOver={e=>{e.preventDefault(); if(!surukleniyor) setSurukleniyor(true);}}
            onDragLeave={e=>{ if(!e.currentTarget.contains(e.relatedTarget)) setSurukleniyor(false); }}
            onDrop={e=>{e.preventDefault(); setSurukleniyor(false); fotografYukle(e.dataTransfer.files);}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8,gap:8,flexWrap:'wrap'}}>
              <span style={{color:'#94a3b8',fontSize:14,fontWeight:600}}>Fotograflar ({fotograflar.length}){fotograflar.some(fo=>fo.disaridan)?` · ${fotograflar.filter(fo=>fo.disaridan).length} disaridan`:''}</span>
              <label style={{background:fotoYukleniyor?'#1e3a8a':'#2563eb',color:'#fff',border:'none',borderRadius:8,padding:'8px 16px',cursor:'pointer',fontSize:13,fontWeight:600}}>
                {fotoYukleniyor?'Yukleniyor...':'+ Fotograf Ekle'}
                <input type="file" multiple accept="image/*" style={{display:'none'}} onChange={e=>fotografYukle(e.target.files)} disabled={fotoYukleniyor}/>
              </label>
            </div>
            <label style={{display:'flex',alignItems:'flex-start',gap:8,fontSize:13,color:disaridanMod?'#b45309':'#64748b',background:disaridanMod?'#fef3c7':'transparent',borderRadius:6,padding:'6px 8px',marginBottom:8,cursor:'pointer'}}>
              <input type="checkbox" checked={disaridanMod} onChange={e=>setDisaridanMod(e.target.checked)} style={{marginTop:2}}/>
              <span><b>Bu fotograflar baska bir ilandan alindi</b> — sadece ekip ici kullanilir; tanitim videosuna, sosyal medyaya ve musteriye giden mesajlara eklenmez.</span>
            </label>
            <div style={{display:'flex',gap:8,marginBottom:10,flexWrap:'wrap'}}>
              <div contentEditable suppressContentEditableWarning tabIndex={0}
                onPaste={e=>{ e.preventDefault(); e.stopPropagation(); const items=Array.from((e.clipboardData&&e.clipboardData.items)||[]); const d=items.filter(it=>it.kind==='file'&&it.type.startsWith('image/')).map(it=>it.getAsFile()).filter(Boolean); if(d.length) fotografYukle(d); else if(e.clipboardData&&e.clipboardData.files&&e.clipboardData.files.length) fotografYukle(e.clipboardData.files); else alert('Panoda resim bulunamadi. Once Windows+Shift+S ile alinti alin.'); }}
                onKeyDown={e=>{ if(!(e.ctrlKey||e.metaKey)) e.preventDefault(); }}
                style={{flex:1,minWidth:220,border:'2px dashed #475569',borderRadius:8,padding:'14px 10px',textAlign:'center',color:'#94a3b8',fontSize:13,cursor:'text',outline:'none',caretColor:'transparent'}}>
                {fotoYukleniyor ? 'Yukleniyor...' : 'Fotograflari buraya surukleyin — ya da BURAYA TIKLAYIP Ctrl+V yapin'}
              </div>
              <button type="button" onClick={panodanYapistir} disabled={fotoYukleniyor} style={{background:'#0f766e',color:'#fff',border:'none',borderRadius:8,padding:'10px 16px',cursor:'pointer',fontSize:13,fontWeight:700,whiteSpace:'nowrap'}}>📋 Panodaki Resmi Yapistir</button>
            </div>
            {fotograflar.length===0?(
              <p style={{color:'#64748b',fontSize:13,textAlign:'center',padding:'8px 0'}}>Henuz fotograf eklenmedi</p>
            ):(
              <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(130px,1fr))',gap:8}}>
                {fotograflar.map(foto=>(
                  <div key={foto.id} style={{position:'relative',borderRadius:8,overflow:'hidden',background:'#0f172a',border:foto.ana_fotograf?'2px solid #f59e0b':'2px solid #1e293b'}}>
                    <img src={foto.dosya_yolu} alt="" style={{width:'100%',height:90,objectFit:'cover',display:'block'}}/>
                    {foto.ana_fotograf&&(<span style={{position:'absolute',top:4,left:4,background:'#f59e0b',color:'#000',fontSize:10,fontWeight:700,padding:'2px 6px',borderRadius:4}}>ANA</span>)}
                    {foto.disaridan&&(<span style={{position:'absolute',top:4,right:4,background:'#b45309',color:'#fff',fontSize:9,fontWeight:700,padding:'2px 5px',borderRadius:4}}>DISARIDAN · YAYINLANMAZ</span>)}
                    <div style={{display:'flex',gap:4,padding:'4px',background:'rgba(0,0,0,0.6)'}}>
                      {!foto.ana_fotograf&&(<button onClick={()=>anaFotoSec(foto.id)} style={{flex:1,background:'#1e40af',color:'#fff',border:'none',borderRadius:4,padding:'3px 0',fontSize:10,cursor:'pointer',fontWeight:600}}>Ana</button>)}
                      <button onClick={()=>disaridanDegistir(foto)} title={foto.disaridan?'Izin alindi / kendi fotografimiz: yayinlanabilir yap':'Baska ilandan alindi: yayinlanmaz yap'} style={{flex:1,background:foto.disaridan?'#15803d':'#92400e',color:'#fff',border:'none',borderRadius:4,padding:'3px 0',fontSize:10,cursor:'pointer',fontWeight:600}}>{foto.disaridan?'Izinli':'Disaridan'}</button>
                      <button onClick={()=>fotografSilFunc(foto.id)} style={{flex:1,background:'#dc2626',color:'#fff',border:'none',borderRadius:4,padding:'3px 0',fontSize:10,cursor:'pointer',fontWeight:600}}>Sil</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
          </div>
        </div>
      )}
    </div>
  );
}
